import type { AgentMode } from "../api/types";

interface ModeMeta {
  id: AgentMode;
  title: string;
  description: string;
}

const MODES: ModeMeta[] = [
  {
    id: "bafa",
    title: "BAFA Beratungsbericht",
    description: "ESF-Plus-konforme Berichte für Lead Easy, Sorhage & weitere Berater",
  },
  {
    id: "inqa",
    title: "INQA Projektreferenz",
    description: "Kundenreferenzen für das INQA-Coach-Autorisierungsverfahren",
  },
  {
    id: "qm_handbuch",
    title: "QM Handbuch",
    description: "Qualitätsmanagement-Handbuch für Beratungsunternehmen",
  },
  {
    id: "custom_document",
    title: "Eigenes Dokument",
    description: "Eigene Texte erstellen, per KI bearbeiten und als DOCX/PDF exportieren",
  },
];

interface Props {
  current: AgentMode;
  enabled: AgentMode[];
  onChange: (mode: AgentMode) => void;
}

export function ModeSelector({ current, enabled, onChange }: Props) {
  const visible = MODES.filter((m) => enabled.includes(m.id));
  return (
    <div className="mode-selector">
      <h2>Modus wählen</h2>
      <div className="mode-cards">
        {visible.map((m) => (
          <div key={m.id} className="mode-card-wrapper">
            <button
              type="button"
              className={`mode-card${m.id === current ? " active" : ""}`}
              onClick={() => onChange(m.id)}
            >
              <div className="mode-title">{m.title}</div>
              <div className="mode-desc">{m.description}</div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
